module.exports = __webpack_public_path__ + "static/media/A0538_spectra_high.4f263fd5.png";